import styled, { css } from 'styled-components';
import { Modal } from 'src/components';
import newExperienceImage from './new-experience-image.png';

export const ModalWrapper = styled(Modal)(() => css``);

export const ModalContent = styled.div(
  () => css`
    min-height: calc(100% - 168px);
  `,
);

export const NewExperienceModalContent = styled.div<{ $isHybrid?: boolean }>(
  ({ theme, $isHybrid }) => css`
    min-height: calc(100% - 108px);

    @media (min-height: ${$isHybrid ? theme.sz.xl : theme.sz.lg}) {
      background-image: url(${newExperienceImage});
      background-size: ${theme.sz.xs} auto;
      background-repeat: no-repeat;
      background-position: bottom center;
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    margin: 0 ${theme.sz.s4};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};
    padding-bottom: ${theme.sz.s4};

    @media (max-width: ${theme.sz.ml}) {
      gap: ${theme.sz.s2};
    }
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    width: 100%;
    background: ${theme.co.primary20};
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    padding: ${theme.sz.s16} 0;
    align-items: center;
    text-align: center;

    @media (max-width: ${theme.sz.ml}) {
      gap: ${theme.sz.s4};
      padding: ${theme.sz.s8} ${theme.sz.s4};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.l};

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.heading.mobile.m};
    }
  `,
);

export const DescriptionUGC = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    padding-top: ${theme.sz.s8};
    padding-bottom: ${theme.sz.s6};
    max-width: ${theme.sz.md};
    text-align: center;

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.paragraph.base};
      padding-top: ${theme.sz.s4};
      padding-bottom: ${theme.sz.s2};
    }
  `,
);

export const DescriptionHybrid = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    padding-top: ${theme.sz.s8};
    padding-bottom: ${theme.sz.s6};
    max-width: ${theme.sz.md};
    text-align: center;

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.heading.mobile.s};
      padding-top: ${theme.sz.s4};
      padding-bottom: ${theme.sz.s2};
    }
  `,
);

export const DescriptionHybridSecondary = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    text-align: center;
    max-width: ${theme.sz.s};

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.paragraph.base};
    }
  `,
);

export const DescriptionList = styled.ul(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    padding: ${theme.sz.s0};
    list-style-type: none;
  `,
);

export const DescriptionListItem = styled.li(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    max-width: ${theme.sz.md};
    margin-bottom: ${theme.sz.s8};
    text-align: center;

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.paragraph.base};
      text-align: left;
    }
  `,
);

export const BoldText = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const LinkTag = styled.a(
  ({ theme }) => css`
    color: ${theme.co.information50};

    &:active,
    &:active:visited,
    &:hover,
    &:hover:visited,
    &:focus,
    &:focus:visited {
      color: ${theme.co.information40};
    }
  `,
);

export const TitleIntro = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    margin: auto;
    max-width: ${theme.sz.md};

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.paragraph.base};
    }
  `,
);

export const Subtitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};
    margin: auto;
    max-width: ${theme.sz.md};

    @media (max-width: ${theme.sz.ml}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const ButtonWrapperFooter = styled.div(
  ({ theme }) => css`
    position: sticky;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 0;
    padding: ${theme.sz.s4};
    background-color: ${theme.co.secondary20};
    gap: ${theme.sz.s4};
    padding: ${theme.sz.s8} ${theme.sz.s4};

    button,
    a {
      min-width: ${theme.sz.m};
    }

    @media (max-width: ${theme.sz.m}) {
      button,
      a {
        min-width: 100%;
      }
    }
  `,
);

export const LoaderContainer = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s40} auto 0 auto;
    width: ${theme.sz.s40};
    height: 100dvh;
    @media (max-width: ${theme.sz.xl}) {
      width: ${theme.sz.s12};
    }
  `,
);

export const ErrorWrapper = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s6};
    margin-bottom: -${theme.sz.s8};
  `,
);
